export default __webpack_public_path__ + "static/media/icon_ethereum.92fe4261.png";